/**
 * 终端判断
 *
 * 站内电脑端与手机端是两套排版（靠 UA 切换，不是响应式缩放），
 * 原来这段正则散落在各个产品页里，统一收到这里，避免各页判断口径不一致。
 */
const MOBILE_RE = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i

export function isMobileUA () {
  if (typeof navigator === 'undefined') return false
  return MOBILE_RE.test(navigator.userAgent)
}

export default isMobileUA
